import { render } from "./BrandsList.vue?vue&type=template&id=726287c6&scoped=true"
import script from "./BrandsList.vue?vue&type=script&lang=js"
export * from "./BrandsList.vue?vue&type=script&lang=js"

import "./BrandsList.vue?vue&type=style&index=0&id=726287c6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-726287c6"]])

export default __exports__